// src/api/authEvents.ts
//
// V12 Auth Event Contract — frozen 2026-06-12.
//
// Canonical signal emitted by fetchWithAuth (src/api/authClient.ts) when
// the server reports 401. The Router (src/router/routes.tsx) is the sole
// subscriber; it owns navigation in response.
//
// Rules:
//   - Event NAME must come from AUTH_401_EVENT. Do not inline the string.
//   - Detail payload must conform to Auth401EventDetail. Do not extend
//     silently — add fields here, then update both producer and consumer.
//   - Adding new auth events (e.g. 403, session-expire, token-refresh):
//     define the constant + type here, then wire producer/consumer.

export const AUTH_401_EVENT = 'v12-auth-401';

export interface Auth401EventDetail {
  /** Path + search the user was on when the 401 fired. Router uses this
   *  to round-trip the user back after a successful login. */
  from: string;
}
